<template>
  <label for="branch-places-multiselect-component" class="form-label">
    {{ $t('branch.place.name') }}
  </label>
  <TomSelect
    v-model="componentValue.selectedBranchPlace"
    :options="{
      create: false,
      placeholder: $t('branch.place.select')
    }"
    class="w-full"
  >
    <option :value="null" key="_null">
      {{ $t('branch.place.nullSelect') }}
    </option>
    <option
      v-for="branchPlace in branchPlaces"
      :value="branchPlace.uuid"
      :key="branchPlace.uuid"
    >
      {{ branchPlace.internalName }} - ({{ branchPlace.branch.name }})
    </option>
  </TomSelect>
</template>

<script>
import { defineComponent, computed } from 'vue'
import branchPlaceApi from '../../services/branches/branch-place.api'

export default defineComponent({
  data() {
    return {
      branchPlaces: []
    }
  },
  mounted() {
    branchPlaceApi.getListAll(1, 1000).then(
      response => {
        this.branchPlaces = response.data.data
      },
      error => {
        alert(error)
      }
    )
  },
  props: {
    selectedBranchPlace: {
      type: Object,
      default: () => {}
    }
  },

  emits: ['update:selectedBranchPlace'],

  setup(props, { emit }) {
    const componentValue = computed({
      get: () => props.selectedBranchPlace,
      set: value => emit('update:selectedBranchPlace', value)
    })

    return {
      componentValue
    }
  }
})
</script>
